export type AlertType = 'error' | 'warning' | 'info' | 'success';

export enum AlertTypes {
  error = 'error',
  warning = 'warning',
  info = 'info',
  success = 'success',
}

export interface AlertMessage {
  title?: string;
  description: string;
  type?: AlertType;
}
